import React from "react";
import PropTypes from "prop-types";
import useTranslation from "../hooks/use-translation";

function Translation(props) {

    const options = {
        data: props.data,
        count: props.count
    };

    const translation = useTranslation(props.name, options, props.defaultValue);

    if(typeof props.onClick === 'function') {
        return (
            <span onClick={props.onClick} className={props.className}>
                {translation}
            </span>
        )
    }

    return translation;
}

Translation.defaultProps = {
    name: null,
    data: {},
    count: null,
    defaultValue: null,
    className: '',
}

Translation.propTypes = {
    name: PropTypes.string.isRequired,
    data: PropTypes.object,
    count: PropTypes.number,
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onClick: PropTypes.func,
    className: PropTypes.string,
}

export default Translation;

